// Boot-time feature detection for CSS capabilities that older (ES2015-era)
// browsers lack and that styled-components' prefixer cannot polyfill. Each adds
// a class to <html> so stylesheets can provide a scoped fallback. These classes
// are ONLY added on browsers missing the feature, so modern browsers are never
// affected.

// flexbox `gap` — unsupported on Safari < 14.1 / iOS < 14.5, Chrome < 84,
// Firefox < 63, legacy Edge. Detected by measuring a column flex container with
// a row-gap: if gap is honored the two children push the height to 1px.
const supportsFlexGap = (): boolean => {
	const flex = document.createElement("div");
	flex.style.display = "flex";
	flex.style.flexDirection = "column";
	flex.style.rowGap = "1px";
	flex.appendChild(document.createElement("div"));
	flex.appendChild(document.createElement("div"));
	document.body.appendChild(flex);
	const supported = flex.scrollHeight === 1;
	flex.parentNode?.removeChild(flex);
	return supported;
};

// :focus-visible — unsupported on Safari < 15.4, Chrome < 86, Firefox < 85.
// CSS.supports("selector(...)") is itself only in browsers new enough to also
// have :focus-visible, so a false/throw here reliably means "no support".
const supportsFocusVisible = (): boolean => {
	try {
		return (
			typeof CSS !== "undefined" &&
			typeof CSS.supports === "function" &&
			CSS.supports("selector(:focus-visible)")
		);
	} catch {
		return false;
	}
};

export const applyBrowserSupportClasses = (): void => {
	const html = document.documentElement;
	try {
		if (!supportsFlexGap()) {
			html.classList.add("no-flexbox-gap");
		}
	} catch {
		// If detection itself fails (very old/exotic engine), assume the worst.
		html.classList.add("no-flexbox-gap");
	}
	if (!supportsFocusVisible()) {
		html.classList.add("no-focus-visible");
	}
};
